
<template>
  <div id="research_history_list">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>事前現場調査履歴</h2>
            <div class="history_list" v-for="(order,index) in reserchList" :key="'history-' + index">
              <dd-history
                :orderData="order"
                @detail="detail"
              />
            </div>
            <dd-pager
              :pageNo="pageNo"
              :dataCountPerPage="15"
              :totalDataCount="orderResrchList.length"
              @paging="paging"
            />
            <div v-if="reserchList.length <= 0" class="not_history">事前現場調査履歴がありません。</div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'

import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcPager from '../components/common/DcPager'
import DcOrderHistory from '../components/order/DcOrderHistory'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

const PRODUCT_VIEW_SIZE = 15

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-history': DcOrderHistory,
    'dd-loading-modal': LoadingModal,
    'dd-pager': DcPager,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcResearchHistoryList',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'myPage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'researchHistoryList', key: 'dcResearchHistoryList', title: '事前現場調査履歴リスト', route: 'DcResearchHistoryList'}
      ],
      pageNo: 1
    }
  },
  computed: {
    ...mapState(
      {orderResrchList: state => state.orderResrchList}
    ),
    // 表示用商品リスト
    reserchList: function () {
      if (!this.orderResrchList) return []
      let startIdx = (this.pageNo - 1) * PRODUCT_VIEW_SIZE
      let endIdx = this.pageNo * PRODUCT_VIEW_SIZE
      let list = this.orderResrchList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
      return list
    }
  },
  methods: {
    ...mapActions({getOrderResrchList: 'loadOrderResrchList'}),
    paging: function (selPage) {
      this.pageNo = selPage
    },
    detail: function (orderNo) {
      this.$router.push({
        name: 'DcResearchHistoryDetail',
        params: { orderNo: orderNo }
      })
    }
  },
  mounted: function () {
    this.$store.dispatch('loadOrderResrchList', {reload: true})
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcResearchHistoryList.vue